import React, { useRef, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice from '../../../../images/raw_material/rice.png';
import break_box from '../../../../images/product/break_box.png';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';

const Low_Stock_Display = ({ show, onClose }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    paging: false,
                    scrollY: "250px", // Set the scroll height here
                    scrollCollapse: true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);
    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Package Price List</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="table-container">
                        <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-100px text-start'>Date</th>
                                    <th className='min-w-100px text-start'>Image</th>
                                    <th className='min-w-100px text-start'>Raw Material / Category</th>
                                    {/* <th className='min-w-100px text-start'>Raw Material Category</th> */}
                                    <th className='min-w-100px  text-center'>Current Stock</th>
                                    <th className='min-w-100px text-start'>Auto Purchase</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                <tr>
                                    <td className='text-start'>
                                        <label className='text-danger font-w500 fs-7'>17-May-2025</label>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <LightGallery
                                                onInit={onInit}
                                                speed={500}
                                                plugins={[lgThumbnail, lgZoom]}
                                            >
                                                <div data-src={rice} className='border rounded px-1 py-0'>
                                                    <img src={rice} alt="Basmathi Rice" className='cursor-pointer w-45px h-45px' />
                                                </div>
                                            </LightGallery>
                                        </div>
                                    </td>

                                    <td>
                                        <div className="d-flex align-items-center justify-content-start gap-2">

                                            <div>
                                                <label className='text-black font-w400 fs-7'>Basmathi Rice</label>
                                                <div className="d-block">
                                                    <label className="fs-8 text-dark">Grains</label>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    {/* <td className='text-start'>
                                <label className='text-black font-w400 fs-7'>Grain</label>
                            </td> */}
                                    <td className='text-center'>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1'>
                                            <span>3 kg's</span>
                                        </Badge>
                                    </td>
                                    <td className='text-start'>
                                        <div className="form-check form-switch d-flex align-items-center mb-3">
                                            <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked />
                                        </div>
                                    </td>

                                    {/* <td className='text-start'>
                                <label className='text-black font-w400 fs-7'>28-May-2025</label>
                            </td> */}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Low_Stock_Display;
